<template>
	<div class="left-nav">
		<el-menu ref="menu" :default-active='menuId' :default-openeds="openeds" background-color="#2b2e3b"
		 text-color="#ccc" active-text-color="#fff" >
			<template v-for="item in data">
				<sub-menu :data="item" :key="item.id"  v-if="item.isShow==1"></sub-menu>
			</template>
		</el-menu>
	</div>

</template>
<script>
	import subMenu from './sub-menus'
	import eventBus from '@/components/libs/eventBus.js';

	export default {
		components: {
			subMenu
		},
		props: ['data'],
		data() {
			return {
				menuId: '1101',
				openeds:[]
			}
		},
		methods: {
			
			
			
		},
		mounted: function() {
			this.openeds.push(this.data && this.data[0] && [this.data[0].id]);
			// 事件车
			eventBus.$on('menuChange', (e) => {
				this.menuId = e.menuId;
				if(this.$refs.menu){
					this.$refs.menu.updateActiveIndex(this.menuId);
				}
			})
			
			
		},
		created: function() {
			let menuId = sessionStorage.getItem('menuId');
			if (menuId != null) {
				this.menuId = menuId;
			}
		}
	}
</script>
<style scoped>
	.el-menu {
		border: none;
		border-right: none !important;
	}

	.el-menu .is-active {
		background: #A52A2A !important;
		background: #409EFF !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/layout/menu.vue